import React, { forwardRef } from "react"
import TextField from "@material-ui/core/TextField"

const phoneInput = (props, ref) => {
  return <TextField {...props} inputRef={ref} fullWidth />
}
export default forwardRef(phoneInput)
